export const items = [
  {
    label: "Home",
    key: "/",
  },
  {
    label: "Turmeric",
    key: "#/products",
  },
  {
    label: "About Us",
    key: "#/about",
  },
  {
    label: "Blog",
    key: "#/blogs",
  },
  {
    label: "Contact Us",
    key: "#/contact",
  },
];
